import { ToggleSwitch } from 'coreOld/components';
import { ISystemUser } from 'system/types';

import { Center } from './userSettingStyle';

interface IProps {
  checked: boolean;
  user: ISystemUser;
  isLoading: boolean;
  onAllowQuoteReleaseWithoutSendingEmailChange;
}

const UserSettingView = ({
  checked,
  user,
  isLoading,
  onAllowQuoteReleaseWithoutSendingEmailChange,
}: IProps) => {
  return (
    <Center>
      <ToggleSwitch
        name="allowQuoteReleaseWithoutSendingEmail"
        checked={checked}
        onChange={(event) => onAllowQuoteReleaseWithoutSendingEmailChange(event, user.userId)}
        isLoading={isLoading}
      />
    </Center>
  );
};

export default UserSettingView;
